import { AppNS } from 'app';
import { prepareResponseData } from 'app/api/helpers/prepareResponseData';
import { setCurrentLeadJobSwoState } from 'app/store/agency-leads';
import { setCurrentJobSwoState } from 'app/store/client-jobs';
import { WebsocketMessage } from 'app/types';
import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';

export interface SetJobSwoProps {
  message: WebsocketMessage;
}

/**
 * For Job Swo Check
 * @param props
 * @returns
 */
export default function SetJobSwo(props: SetJobSwoProps) {
  const { message } = props;

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!message.model || message?.model?.error) {
    } else {
      // TESTING
      // const data = { ...(prepareResponseData(message.model) as AppNS.Project), swoSetAt: '2001-12-20' };
      const data = prepareResponseData(message.model) as AppNS.Project;

      // for client
      dispatch(setCurrentJobSwoState(data));

      // for agency
      dispatch(setCurrentLeadJobSwoState(data));
    }
  }, [message.uuid]);

  return null;
}
